'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';

import {
  routeConfig
} from './app.config';

import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import sources from './sources/sources.component';

// Public
import landusemap from './landusemap/landusemap.component';
import pdashboard from './pdashboard/pdashboard.component';
import data from './data/data.component';
import detail from './detail/detail.component'
import help from './help/help.component'



// Services
import landuseService from '../components/services/landuse/landuse.service';
import lookupService from '../components/services/lookup/lookup.service';
import mapService from '../components/services/map/map.service';
import themeService from '../components/services/theme/theme.service';
import dbService from '../components/services/db/db.service';

// Factories
import dbFactoryService from '../components/factories/dbFactory/dbFactory.service';

// Libraries 

// Angular Smart Table
import smartTable from 'angular-smart-table';


import './app.css';

angular.module('hessPublicApp', [ngCookies, ngResource, ngSanitize, uiRouter, navbar, smartTable, footer, main,
  constants, util, landusemap, data, detail,help, pdashboard, sources, landuseService, lookupService, mapService, themeService, dbService,
  dbFactoryService
])
  .config(routeConfig);

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['hessPublicApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js